<div class="report-viewer-modal">
    <div class="close-button d-flex justify-content-end">
        <div class="cross-icon" (click)="ngbActiveModal.close()">✖</div>
    </div>
    <dx-report-viewer [reportUrl]="reportUrl">
        <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrl"></dxrv-request-options>
        <dxrv-callbacks (BeforeRender)="operationBeforeRenderReport($event)" (onInit)="operationBeforeRenderReport($event)"></dxrv-callbacks>
    </dx-report-viewer>
</div>
